import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { Dialog, DialogType } from '@fluentui/react/lib/Dialog';
import { DefaultButton, PrimaryButton, IButtonStyles } from '@fluentui/react/lib/Button';
import loc, { format } from 'owa-localize';
import { Icon } from '@fluentui/react/lib/Icon';
import { ControlIcons } from 'owa-control-icons';
import { openGoPremiumUrl } from '../utils/openGoPremiumUrl';
import { logOnUpsellClicked } from '../utils/telemetry/logOnUpsellClicked';
import { UpsellPremiumPreviewBase } from './UpsellPremiumPreviewBase';
import { PremiumPreviewData } from '../store/schema/PremiumPreviewData';
import {
    skittleGoPremiumButton,
    skittleDialogTryItNowButton,
} from './SkittleCallout.locstring.json';
import { NUMBER_OF_DAYS_FREE_TRIAL, NUMBER_OF_SUGGESTIONS } from '../constants';
import { getTextStringSkittle } from '../utils/getTextStringSkittle';
import classNames from 'classnames';

const styles = require('./UpsellSkittle.scss');

const buttonStyles: IButtonStyles = {
    flexContainer: styles.goPremiumButoon,
};
export interface DialogPremiumPreviewSkittleProps {
    onDismiss: () => void;
    onTryItNowClick: (numerOfDaysLeft: number, premiumSuggestionsCount: number) => void;
    premiumPreviewData: PremiumPreviewData;
}

const DialogPremiumPreviewSkittle = observer(function DialogPremiumPreviewSkittle(
    props: DialogPremiumPreviewSkittleProps
) {
    const onGoPremiumClick = React.useCallback(() => {
        openGoPremiumUrl(
            props.premiumPreviewData.premiumPreviewType,
            props.premiumPreviewData.premiumPreviewStatus,
            'Callout'
        );
        logOnUpsellClicked('PremiumPreview', props.premiumPreviewData, '' /* type */);
    }, [
        props.premiumPreviewData.premiumPreviewType,
        props.premiumPreviewData.premiumPreviewStatus,
        props.premiumPreviewData,
    ]);

    const onTryItNowClicked = React.useCallback(() => {
        props.onTryItNowClick(NUMBER_OF_DAYS_FREE_TRIAL, NUMBER_OF_SUGGESTIONS);
    }, []);
    const { stringToShowOnPremiumPreviewCallout, numberToShow } = getTextStringSkittle(
        props.premiumPreviewData,
        NUMBER_OF_DAYS_FREE_TRIAL,
        NUMBER_OF_SUGGESTIONS
    );
    const ariaLable: string = format(loc(stringToShowOnPremiumPreviewCallout), numberToShow);

    return (
        <Dialog
            onDismiss={props.onDismiss}
            forceFocusInsideTrap={true}
            hidden={false}
            dialogContentProps={{ type: DialogType.normal, showCloseButton: true }}
            containerClassName={styles.confirmation}
            firstFocusableSelector={styles.goPremiumButoon}
            modalProps={{
                isBlocking: true,
                className: styles.dialogBox,
            }}>
            <div>
                <UpsellPremiumPreviewBase
                    onTryItNowClick={props.onTryItNowClick}
                    premiumPreviewData={props.premiumPreviewData}
                    onHoverPremiumPreview={null}
                />
                <div className={styles.premPrevbuttonsContainer} aria-label={ariaLable}>
                    <PrimaryButton
                        onClick={onTryItNowClicked}
                        text={loc(skittleDialogTryItNowButton)}
                        className={classNames(styles.tryItNowButoon, styles.goPremiumButoon)}
                    />
                    <DefaultButton
                        onClick={onGoPremiumClick}
                        styles={buttonStyles}
                        text={loc(skittleGoPremiumButton)}
                        className={styles.goPremiumButoon}>
                        <Icon
                            iconName={ControlIcons.Diamond}
                            className={styles.premiumPreviewDiamonIcon}
                        />
                    </DefaultButton>
                </div>
            </div>
        </Dialog>
    );
});

export { DialogPremiumPreviewSkittle };
